import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {environment} from '../../../environments/environment';

@Injectable()
export class CatalogService {
  private apiOrigin = environment.apiOrigin;

  constructor(private http: HttpClient) {
  }

  getPromotions(searchText: string, sortConditions: any, pageSize: number, pageNumber: number): Observable<any> {
    const url = `${this.apiOrigin}/CatalogService/api/promotions/search`;
    const searchCriteria: any = new Object();
    searchCriteria.searchText = searchText;
    searchCriteria.sortConditions = sortConditions;
    searchCriteria.pageSize = pageSize;
    searchCriteria.pageNumber = pageNumber;
    return this.http.post(url, searchCriteria);
  }

  getBrandPromotionalOffers(): Observable<any> {
    const url = `${this.apiOrigin}/CatalogService/api/promotions/brand-wise`;
    return this.http.get(url);
  }

  getProducts(searchText: string) : Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/products/search`;

    return this.http.get(url, {params: new HttpParams().set('searchTerm', searchText)});
  }

  savePromotion(promo: any): Observable<any> {
    const type: string = promo.type;
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/${type}`;
    return this.http.put(url, promo);
  }

  deletePromotion(promoName: string): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotion/${promoName}`;
    return this.http.delete(url);
  }

  getPromotion(promo: any): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotions/${promo.type}/${promo.name}`;
    return this.http.get(url);
  }

  updatePromotionStatus(name: string, action: string) : Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/promotion/status/${action}/${name}`;
    return this.http.post(url, {});
  }

  public deleteCategory(categoryId: string): Observable<any> {
    const url = `${this.apiOrigin}/CatalogService/api/Categories/${categoryId}`;

    return this.http.delete(url);
  }

  public searchProducts(searchText: string, pageSize: number, pageNumber: number): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/products/search`;
    const searchCriteria: any = {};
    searchCriteria.searchText = searchText;
    searchCriteria.pageSize = pageSize;
    searchCriteria.pageNumber = pageNumber;
    return this.http.post(url, searchCriteria);
  }

  public searchCategories(searchText: string, pageSize: number, pageNumber: number): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/categories/search`;
    const searchCriteria: any = {};
    searchCriteria.searchText = searchText;
    searchCriteria.pageSize = pageSize;
    searchCriteria.pageNumber = pageNumber;
    return this.http.post(url, searchCriteria);
  }

  public saveCategory(category: any): Observable<any> {
    const url = `${environment.apiOrigin}/CatalogService/api/categories`;
    return this.http.post(url, category);
  }

  public saveProduct(product: any): Observable<any> {
    const url = `${this.apiOrigin}/CatalogService/api/product`;
    if (product.id == null || product.id === '') {
      return this.http.put(url, product);
    } else {
      return this.http.post(url, product);
    }
  }

  public deleteProduct(productId: string): Observable<any> {
    const url = `${this.apiOrigin}/CatalogService/api/product/${productId}`;

    return this.http.delete(url);
  }
}
